module.exports = __webpack_public_path__ + "img/dex-app.c40c9ed4.svg";